import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export const Problem = () => {
  const problems = ['Perdés horas redactando escritos desde cero.', 'No sabés qué estrategia utilizar frente a determinados reclamos.', 'Tenés dudas sobre cómo fundamentar jurídicamente un caso.', 'Pasás horas buscando jurisprudencia actualizada.', 'No contás con modelos profesionales listos para presentar.'];
  return <section className="py-20 bg-legal-900" data-id="element-204">
      <div className="container mx-auto px-4" data-id="element-205">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-206">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-207">
            ¿Te sentís identificado?
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-208">
          {problems.map((prob, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.08
        }} className="bg-legal-800/50 border border-red-900/30 p-5 rounded-xl flex gap-4 items-start" data-id="element-209">
              <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-210" />
              <p className="text-slate-300 leading-relaxed" data-id="element-211">{prob}</p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="max-w-3xl mx-auto text-center text-lg text-gold-500 font-semibold mt-10" data-id="element-212">
          Si respondiste "sí" a alguna de estas situaciones, este tratado es
          para vos.
        </motion.p>
      </div>
    </section>;
};